export enum SankeyNodeContextMenuAction {
  ExpandByProperty = `breakdown`, // IMPORTANT: ContextMenuEl expects `breakdown` under the hood
  HideEvent = `hide-event`,
  AddCardinality = `add-cardinality`,
  RemoveCardinality = `remove-cardinality`,
  ViewUsers = `view-users`,
}
